import { render, staticRenderFns } from "./ForgetSend.vue?vue&type=template&id=df41a53a&scoped=true&"
import script from "./ForgetSend.vue?vue&type=script&lang=js&"
export * from "./ForgetSend.vue?vue&type=script&lang=js&"
import style0 from "./ForgetSend.vue?vue&type=style&index=0&id=df41a53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df41a53a",
  null
  
)

export default component.exports